import { createSlice } from "@reduxjs/toolkit";

export interface DialogData {
  show: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
}

export type DialogReducerState = Record<string, DialogData>;

const initialState: DialogReducerState = {};

export const dialogSlice = createSlice({
  name: "dialogReducers",
  initialState,
  reducers: {
    onToggle: (state, action) => {
      const dialogName = String(action.payload?.name) || "";
      state[dialogName] = {
        show: !state[dialogName]?.show,
        data: !state[dialogName]?.show ? action.payload?.data || {} : {},
      };
    },
    reset: (state, action) => {
      const dialogName = String(action.payload?.name) || "";
      state[dialogName] = {} as DialogData;
    },
  },
});
